import { render, staticRenderFns } from "./MshiptypesFormHeader.vue?vue&type=template&id=459fca95"
import script from "./MshiptypesFormHeader.vue?vue&type=script&lang=js"
export * from "./MshiptypesFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports